import React from 'react';

const ReloadIcon = ({ ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...rest}>
      <path d="M11.6667 13.3333H15.8334V17.5M8.33336 6.66667H4.16669V2.5M16.1817 7.5025C15.7145 6.34599 14.9321 5.34376 13.9237 4.60972C12.9152 3.87568 11.721 3.43928 10.4769 3.35013C9.23278 3.26098 7.98859 3.52265 6.88576 4.1054C5.78294 4.68814 4.86572 5.56859 4.23836 6.64667M3.81836 12.4975C4.28569 13.6538 5.068 14.6558 6.07638 15.3897C7.08477 16.1236 8.27879 16.5599 9.52277 16.649C10.7667 16.7382 12.0108 16.4766 13.1135 15.894C14.2162 15.3114 15.1334 14.4312 15.7609 13.3533" stroke="#6D7885" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default ReloadIcon;